import { render, staticRenderFns } from "./PolicyPaymentList.vue?vue&type=template&id=d87b577e&"
import script from "./PolicyPaymentList.vue?vue&type=script&lang=js&"
export * from "./PolicyPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports